/**
 * Home-feed card: traffic alerts.
 *
 * Israel has no free public traffic API — Waze keeps theirs private,
 * MOIA / Netivei Israel publish accident logs but not real-time
 * congestion. Until we wire a paid provider (HERE / TomTom) this card
 * shows a "coming soon" placeholder with a link to Google Maps traffic.
 */

export function renderInto(host) {
  if (!host) return;
  host.classList.add('b-mini-card', 'cat-traffic', 'b-row-full');
  host.innerHTML = `
    <div class="b-top-row"><div class="b-badge">🚦</div></div>
    <div>
      <div class="b-title">מצב תנועה בכבישים</div>
      <div class="b-sub" style="font-size:13px;color:var(--ink-600);margin-top:4px;line-height:1.5;">
        בקרוב — שילוב חכם של נתוני תנועה בזמן אמת.<br>
        בינתיים:
        <a href="https://www.waze.com/live-map/" target="_blank" rel="noopener"
           style="color:var(--brand-1);font-weight:600;">Waze Live Map ↗</a>
      </div>
    </div>
  `;
}
